"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _FilterRule_1 = require("./_FilterRule");
exports._FilterRuleList = {
    type: "list",
    flattened: true,
    member: {
        shape: _FilterRule_1._FilterRule
    }
};
//# sourceMappingURL=_FilterRuleList.js.map